var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _vm._v("\n  Сайт использует сервис Google ReCAPTCHA:\n  "),
      _c(
        "a",
        {
          attrs: {
            href: "https://policies.google.com/privacy?hl=ru",
            target: "_blank"
          }
        },
        [_vm._v("\n    Конфиденциальность\n  ")]
      ),
      _vm._v(" \n  и\n  "),
      _c(
        "a",
        {
          attrs: {
            href: "https://policies.google.com/terms?hl=ru",
            target: "_blank"
          }
        },
        [_vm._v("\n    Условия использования\n  ")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }